import $ from 'jquery'
import AssurePrestation from '@/views/parametres/assurances/liste-assures/assure-prestations'

export default {
    name: 'assureur-detail',
    components: {
        AssurePrestation
    },
    props: [],
    data() {
        return {
            is_loading: true
        }
    },
    computed: {
        assureur() {
            return this.$store.getters["assureur"];
        },
    },
    mounted() {
        this.$store.dispatch("getAssuranceById", this.$route.params.id).then(() => {
			console.log("ASSUREUR: ",this.assureur)
			this.is_loading = false
		});
    },
    methods: {
        changeTab(tabindex, t) {

            if (t == 1) {
                $('#shown-tab-' + tabindex).addClass('active show');

                for (let i = 1; i <= 4; i++) {
                    if (i != tabindex) {
                        $('#shown-tab-' + i).removeClass('active show');
                    }
                }
            } else {
                $('#hidden-tab-' + tabindex).addClass('active show');

                for (let i = 1; i <= 4; i++) {
                    if (i != tabindex) {
                        $('#hidden-tab-' + i).removeClass('active show');
                    }
                }
            }
        },
    }
}


